
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import 'swiper/swiper-bundle.css';

//-----------------------------------------
// FV
//-----------------------------------------
// init Swiper:
var swiper = new Swiper('.casestudy-swiper', {
	// Optional parameters
	// direction: 'vertical',
	loop: true,
	slidesPerView: 'auto',
	spaceBetween: 20,
	autoplay: {
        delay: 4000,
        disableOnInteraction: false,
	},
	speed: 1000,
	breakpoints: {
		769: {
			spaceBetween: 48,
		},
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});



